import React from 'react';

import { useAnimateInRef } from '../../../utils/hooks';

import * as styles from './Temperature.module.scss';

interface TemperatureProps {
  weather: string;
  temperature: number;
}

const Temperature = ({ weather, temperature }: TemperatureProps): React.ReactElement => {
  return (
    <section className={styles.currentCondition}>
      <div className={styles.wrapperTemperature}>
        <span ref={useAnimateInRef(styles.animateIn, 550)} className={styles.status}>
          {weather}
        </span>
        <div className={styles.temperature}>
          <span ref={useAnimateInRef(styles.animateIn, 650)} className={styles.value}>
            {Math.round(temperature)}
          </span>
          <div ref={useAnimateInRef(styles.animateIn, 600)} className={styles.unit}>
            <span className={styles.unitDot}></span>
            <span className={styles.unitLetter}>c</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Temperature;
